import { VERIFICATIONS } from 'utils/reducers';

const initialState = {
    show: false,
};

const showVerificationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case VERIFICATIONS.display:
            return { ...state, show: true };
        case VERIFICATIONS.hide:
            return { ...state, show: false };
        default:
            return state;
    }
};

export default showVerificationsReducer;
